class IaOpenRoles extends HTMLElement {
  connectedCallback() {
    this.filters = this.querySelectorAll('[data-filter]');
    this.items = this.querySelectorAll('.ia-open-roles__item');
    this.noResultsMessage = this.querySelector('.ia-open-roles__no-results');
    
    this.filters.forEach(filter => {
      filter.addEventListener('change', this.handleFilter.bind(this));
    });
  }

  handleFilter() {
    const selectedExperience = this.querySelector('[data-filter="experience"]')?.value || '';
    const selectedLocation = this.querySelector('[data-filter="location"]')?.value || '';
    const selectedCategory = this.querySelector('[data-filter="category"]')?.value || '';

    let visibleCount = 0;

    this.items.forEach(item => {
      const itemExperience = item.dataset.experience || '';
      const itemCategory = item.dataset.category || '';
      const itemLocationText = item.querySelector('.ia-open-roles__item-location')?.textContent || '';

      const matchesExperience = !selectedExperience || itemExperience === selectedExperience;
      const matchesCategory = !selectedCategory || itemCategory === selectedCategory;
      const matchesLocation = !selectedLocation || itemLocationText.includes(selectedLocation);

      if (matchesExperience && matchesCategory && matchesLocation) {
        item.style.display = '';
        visibleCount++;
      } else {
        item.style.display = 'none';
      }
    });

    if (this.noResultsMessage) {
      this.noResultsMessage.style.display = visibleCount === 0 ? '' : 'none';
    }
  }
}

customElements.define('ia-open-roles', IaOpenRoles);
